import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from 'app/design-system/components/Icon';
import { ICON_NAME_MICRO_CHEVRON_RIGHT } from 'app/design-system/constants/IconNames';
import { IconSize } from 'app/design-system/types/Icon';
import { useTranslation } from 'app/lang';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import dictionary from './DropdownFooter.dictionary.json';

import styles from './DropdownFooter.module.scss';

type Props = {
  unreadCount: number;
  onClick?: () => void;
};

export const DropdownFooter: FC<Props> = ({ unreadCount, onClick }) => {
  const { t } = useTranslation();

  return (
    <Link
      to={ROUTE_PATH.NOTIFICATIONS}
      className={styles.root}
      onClick={onClick}
      data-ga-event="header_notifications_go_to_all">
      {t(dictionary.link, { count: unreadCount })}
      <Icon
        className={styles.chevronRightIcon}
        icon={ICON_NAME_MICRO_CHEVRON_RIGHT}
        size={IconSize.SMALL} />
    </Link>
  );
};
